import { useEffect, useRef } from 'react'
import { buildContactMailtoUrl, CONTACT_EMAIL } from '@/constants/contact'
import { STORE_INFO } from '@/constants/store-info'
import { createEditorialRevealAnimation } from '@/lib/gsap/editorial-reveals'

const INFO_CARD_SELECTOR = '.fz-sobre-page__info-card'

export interface SobreInfoCard {
  label: string
  lines: string[]
  href?: string
  linkLabel?: string
}

export function useSobrePageModel() {
  const infoGridRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const animation = createEditorialRevealAnimation(
      infoGridRef.current,
      INFO_CARD_SELECTOR,
    )
    return () => animation?.revert()
  }, [])

  const infoCards: SobreInfoCard[] = [
    {
      label: 'Entrega',
      lines: [`Em ${STORE_INFO.deliveryArea}`, 'Combinada por e-mail'],
    },
    {
      label: 'Horário',
      lines: [STORE_INFO.hoursWeekdays, STORE_INFO.hoursSunday],
    },
    {
      label: 'E-mail',
      lines: [CONTACT_EMAIL],
      href: buildContactMailtoUrl(),
      linkLabel: 'Escrever para o ateliê',
    },
  ]

  return {
    slogan: STORE_INFO.slogan,
    infoCards,
    infoGridRef,
  }
}
